import ModalCopyBenchmarks from "./modal-copy-benchmarks";

export default ModalCopyBenchmarks;
